import React from 'react';
import PropTypes from 'prop-types';
import BooleanOption from './BooleanOption';
import TextOption from './TextOption';
import NumberOption from './NumberOption';

const OPTION_COMPONENTS_BY_DATA_TYPE = {
  boolean: BooleanOption,
  string: TextOption,
  integer: NumberOption
};

export default class RideOption extends React.Component {
  constructor(props) {
    super(props);

    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(value) {
    const optionSlug = this.props.option.slug;
    this.props.handleUpdate(optionSlug, value);
  }

  render() {
    const { option } = this.props;
    const SpecificOptionClass = OPTION_COMPONENTS_BY_DATA_TYPE[option.data_type] || BooleanOption;
    return (
      <div className="col d-none d-xl-block pr-0">
        <SpecificOptionClass
          value={this.props.value}
          handleUpdate={this.handleOptionChange}
          disabled={this.props.disabled}
          optionSlug={this.props.option.slug} // for debugging purposes
        />
      </div>
    );
  }
}
RideOption.propTypes = {
    disabled: false
};

RideOption.propTypes = {
    option: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
    ]),
    handleUpdate: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};
